// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.salesforce-manager-form {
  width: 100%;
  max-width: 720px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.salesforce-manager-form__group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
}
.salesforce-manager-form__group:last-child {
  margin-top: 8px;
  margin-bottom: 0;
  flex-direction: row;
  justify-content: flex-start;
  gap: 12px;
}
.salesforce-manager-form__label {
  font-size: 14px;
  font-weight: 500;
  color: #142A31;
}
.salesforce-manager-form__error {
  font-size: 12px;
  color: #dc2626;
  margin-bottom: 0;
}
.salesforce-manager-form__input {
  appearance: none;
  width: 100%;
  height: 34px;
  padding: 0 12px;
  border: 1px solid #D3E1ED;
  border-radius: 5px;
  background: #ffffff;
  color: #142A31;
  line-height: 1.4;
  box-sizing: border-box;
  font-size: 14px;
  transition: border-color 160ms ease, box-shadow 160ms ease;
}
.salesforce-manager-form__input::placeholder {
  color: #6b7280;
}
.salesforce-manager-form__input:hover {
  border-color: rgb(189.2838709677, 210.1935483871, 228.1161290323);
}
.salesforce-manager-form__input:focus {
  outline: none;
  border-color: #40a0c1;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.25);
}
.salesforce-manager-form__input:disabled {
  color: #6b7280;
  background: #f9fafb;
  cursor: not-allowed;
}
.salesforce-manager-form__button {
  appearance: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 35px;
  min-width: 70px;
  padding: 0px 10px;
  border: 1px solid transparent;
  border-radius: 45px;
  background: #40a0c1;
  color: #ffffff;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  box-sizing: border-box;
  transition: background-color 160ms ease, transform 60ms ease, box-shadow 160ms ease;
}
.salesforce-manager-form__button:hover {
  background: rgb(55.4814229249, 141.3881422925, 170.9185770751);
}
.salesforce-manager-form__button:active {
  background: rgb(47.9826086957, 122.2782608696, 147.8173913043);
  transform: translateY(0.5px);
}
.salesforce-manager-form__button:disabled {
  background: #9ca3af;
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/pages/Settings/SalesforceManagers/salesforce-manager.scss"],"names":[],"mappings":"AAYA;EACE,WAAA;EACA,gBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAXF;AAaE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,mBAAA;AAXJ;AAaI;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,2BAAA;EACA,SAAA;AAXN;AAeE;EACE,eAAA;EACA,gBAAA;EACA,cAtCY;AAyBhB;AAgBE;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AAdJ;AAiBE;EACE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAnDU;EAoDV,cAvDY;EAwDZ,gBAAA;EACA,sBAAA;EACA,eAAA;EACA,0DAAA;AAfJ;AAiBI;EACE,cA7DW;AA8CjB;AAkBI;EACE,iEAAA;AAhBN;AAmBI;EACE,aAAA;EACA,qBAlEa;EAmEb,6CA9DY;AA6ClB;AAoBI;EACE,cA3EW;EA4EX,mBAAA;EACA,mBAAA;AAlBN;AAsBE;EACE,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,6BAAA;EACA,mBAlFQ;EAmFR,mBAvFe;EAwFf,cAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,sBAAA;EACA,mFAAA;AApBJ;AAsBI;EACE,8DA/FmB;AA2EzB;AAuBI;EACE,8DAlGoB;EAmGpB,4BAAA;AArBN;AAwBI;EACE,mBAAA;EACA,mBAAA;AAtBN","sourcesContent":["$sm-color-text: #142A31;\n$sm-color-muted: #6b7280;\n$sm-color-border: #D3E1ED;\n$sm-color-bg: #ffffff;\n\n$sm-color-primary: #40a0c1;\n$sm-color-primary-hover: darken($sm-color-primary, 6%);\n$sm-color-primary-active: darken($sm-color-primary, 12%);\n\n$sm-radius: 45px;\n$sm-shadow-focus: 0 0 0 3px rgba(37, 99, 235, 0.25);\n\n.salesforce-manager-form {\n  width: 100%;\n  max-width: 720px;\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n\n  &__group {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    margin-bottom: 16px;\n\n    &:last-child {\n      margin-top: 8px;\n      margin-bottom: 0;\n      flex-direction: row;\n      justify-content: flex-start;\n      gap: 12px;\n    }\n  }\n\n  &__label {\n    font-size: 14px;\n    font-weight: 500;\n    color: $sm-color-text;\n  }\n\n  &__error {\n    font-size: 12px;\n    color: #dc2626;\n    margin-bottom: 0;\n  }\n\n  &__input {\n    appearance: none;\n    width: 100%;\n    height: 34px;\n    padding: 0 12px;\n    border: 1px solid $sm-color-border;\n    border-radius: 5px;\n    background: $sm-color-bg;\n    color: $sm-color-text;\n    line-height: 1.4;\n    box-sizing: border-box;\n    font-size: 14px;\n    transition: border-color 160ms ease, box-shadow 160ms ease;\n\n    &::placeholder {\n      color: $sm-color-muted;\n    }\n\n    &:hover {\n      border-color: darken($sm-color-border, 6%);\n    }\n\n    &:focus {\n      outline: none;\n      border-color: $sm-color-primary;\n      box-shadow: $sm-shadow-focus;\n    }\n\n    &:disabled {\n      color: $sm-color-muted;\n      background: #f9fafb;\n      cursor: not-allowed;\n    }\n  }\n\n  &__button {\n    appearance: none;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    height: 35px;\n    min-width: 70px;\n    padding: 0px 10px;\n    border: 1px solid transparent;\n    border-radius: $sm-radius;\n    background: $sm-color-primary;\n    color: #ffffff;\n    font-weight: 700;\n    font-size: 14px;\n    cursor: pointer;\n    box-sizing: border-box;\n    transition: background-color 160ms ease, transform 60ms ease, box-shadow 160ms ease;\n\n    &:hover {\n      background: $sm-color-primary-hover;\n    }\n\n    &:active {\n      background: $sm-color-primary-active;\n      transform: translateY(0.5px);\n    }\n\n    &:disabled {\n      background: #9ca3af;\n      cursor: not-allowed;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
